import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';
import { EmailSendStatus } from './Api';

export const MarketingCampaignsApi = {
    get: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['marketingCampaigns', 'get', webinarId], (api) => api.marketingCampaigns.get(webinarId), options),
    getDetail: (webinarId: string, id: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['marketingCampaigns', 'getDetail', webinarId, id], (api) => api.marketingCampaigns.getDetail({ webinarId, id }), options),
    getLists: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['marketingCampaigns', 'getLists', webinarId], (api) => api.marketingCampaigns.getLists(webinarId), options),
    getRecipients: (
        data: { webinarId: string; id: string; skip: number; take: number; search?: string; status?: EmailSendStatus },
        options?: BaseApiQueryOptions
    ) =>
        apiQueryOptions(
            ['marketingCampaigns', 'getRecipients', data.webinarId, data.id, data.skip, data.take, data.search ?? '', data.status ?? ''],
            (api) => api.marketingCampaigns.getRecipients(data),
            options
        ),
    create: (options?: BaseApiMutationOptions<ApiClient['marketingCampaigns']['create']>) =>
        apiMutationOptions((api) => api.marketingCampaigns.create, options),
    update: (options?: BaseApiMutationOptions<ApiClient['marketingCampaigns']['update']>) =>
        apiMutationOptions((api) => api.marketingCampaigns.update, options),
    send: (options?: BaseApiMutationOptions<ApiClient['marketingCampaigns']['send']>) => apiMutationOptions((api) => api.marketingCampaigns.send, options),
    sendMore: (options?: BaseApiMutationOptions<ApiClient['marketingCampaigns']['sendMore']>) =>
        apiMutationOptions((api) => api.marketingCampaigns.sendMore, options),
    remove: (options?: BaseApiMutationOptions<ApiClient['marketingCampaigns']['remove']>) => apiMutationOptions((api) => api.marketingCampaigns.remove, options)
};
